const getCspOperationStatusList = state  => state.cspList;
const isCspListLoading = state => state.isCspListLoading;

const selectedVendor = state => state.selectedVendor;

export default {
  selectedVendor,
  getCspOperationStatusList,
  isCspListLoading,
};



// WEBPACK FOOTER //
// ./src/store/modules/mis-operation-status/csp-operation-status/getters.js